// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3ozqa","footer":"Form_footer__1bw5y"};